import { sendAnalytics } from '@storefront/app/analytics/SimpleTriggerEvent';
import { ProductConfiguration } from '@storefront/types/Product';
import { BundleProduct } from '@storefront/data-commerce';
import {
  ProductType as UdlProductType,
  UdlStoreState,
} from '@storefront/hooks/useUdl';
import { uiEvents } from '@storefront/services/DataCollection/simpleUiEvents';
import udlEvents from '@storefront/services/udl/udlEvents';

export const logAnalytics = async (
  configuration: ProductConfiguration,
  bundleProducts: BundleProduct[],
  udlStore: UdlStoreState,
  tracingId?: string
) => {
  const actionAuxParams: string[] = [];
  const udlProducts: UdlProductType[] = [];
  const currentProduct = bundleProducts.find(
    (item) => item.sku === configuration.activeSku
  );
  const bundleOptionsEntries = Object.entries(
    configuration[currentProduct.sku]
  );
  bundleOptionsEntries.forEach(([uidForItems, uidForOptions]) => {
    const {
      hp_product_type_label: currentProductLabel,
      sku: currentProductSku,
    } = currentProduct.items[0].options[0].product;
    if (currentProductLabel === 'printer') {
      actionAuxParams.push(`${currentProductLabel}=${currentProductSku}`);
      const udlProduct: UdlProductType = {
        name: currentProduct.items[0].options[0].label,
        category: currentProductLabel,
        id: currentProductSku,
        quantity: currentProduct.items[0].options[0].quantity,
        price: currentProduct.items[0].options[0].lowest_price,
      };
      udlProducts.push(udlProduct);
    }
    const productOption = currentProduct.items
      .find((item) => item.uid === uidForItems)
      .options.find((opt) => opt.uid === uidForOptions);
    const { hp_product_type_label, sku } = productOption.product;
    actionAuxParams.push(`${hp_product_type_label}=${sku}`);
    const udlProduct: UdlProductType = {
      name: productOption.label,
      category: hp_product_type_label,
      id: sku,
      quantity: productOption.quantity,
      price: productOption.lowest_price,
    };
    udlProducts.push(udlProduct);
  });

  await sendAnalytics({
    simpleUiEvent: uiEvents.reviewCartCheckoutPrinter,
    override: {
      actionAuxParams: actionAuxParams.join('&'),
    },
    additionalInformation: {
      eventTracingId: tracingId,
    },
  });

  udlStore.trackEvent({
    ...udlEvents.getEventByID('checkoutButtonClicked'),
    ecommerce: {
      currencyCode:
        currentProduct.price_range?.minimum_price?.regular_price?.currency,
      add: {
        newCart: true,
        detail: { actionField: { list: 'PDP Config' } },
        products: udlProducts,
      },
    },
  });
};
